import { useState } from "react";

const facilities = [
  { name: "Little Rock Main Post Office", address: "600 E Capitol Ave, Little Rock, AR 72201", phone: "(501) 324-5922", hours: "Mon–Fri 9:00 AM – 4:00 PM", wait: "30–60 min" },
  { name: "John L. McClellan Station", address: "PO Box 1920, Little Rock, AR 72203", phone: "(501) 324-5922", hours: "Mon–Fri 9:00 AM – 3:00 PM", wait: "20–45 min" },
  { name: "Pulaski County Clerk's Office", address: "401 W Markham St, Little Rock, AR 72201", phone: "(501) 340-8383", hours: "Mon–Fri 8:00 AM – 4:30 PM", wait: "15–30 min" },
  { name: "North Little Rock Post Office", address: "300 Main St, North Little Rock, AR 72114", phone: "(501) 758-2390", hours: "Mon–Fri 9:00 AM – 4:00 PM", wait: "20–40 min" },
];

export default function LittleRockAcceptanceFacilitiesSection() {
  const [open, setOpen] = useState<number | null>(0);
  return (
    <section id="facilities" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Acceptance Facilities</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">Passport Acceptance Facilities Near Little Rock</h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base">We help you find the facility with the shortest wait time and guide you through the acceptance clerk process.</p>
        </div>
        <div className="space-y-4 max-w-3xl mx-auto">
          {facilities.map((f, i) => (
            <div key={i} className="border border-gray-200 rounded-lg bg-white overflow-hidden">
              <button onClick={() => setOpen(open === i ? null : i)} className="w-full flex items-center justify-between p-5 text-left">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8]">
                    <i className="ri-map-pin-line text-[#1A365D]"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-[#1A365D] text-base">{f.name}</h3>
                    <p className="text-gray-400 text-xs">{f.address}</p>
                  </div>
                </div>
                <i className={`${open === i ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} text-gray-400 text-xl`}></i>
              </button>
              {open === i && (
                <div className="px-5 pb-5 pt-0 border-t border-gray-100">
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mt-4">
                    <div className="bg-[#F7F8FA] rounded-lg p-3">
                      <p className="text-gray-400 text-xs mb-1">Phone</p>
                      <p className="text-[#1A365D] text-sm font-medium">{f.phone}</p>
                    </div>
                    <div className="bg-[#F7F8FA] rounded-lg p-3">
                      <p className="text-gray-400 text-xs mb-1">Hours</p>
                      <p className="text-[#1A365D] text-sm font-medium">{f.hours}</p>
                    </div>
                    <div className="bg-[#F7F8FA] rounded-lg p-3">
                      <p className="text-gray-400 text-xs mb-1">Wait Time</p>
                      <p className="text-[#1A365D] text-sm font-medium">{f.wait}</p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}